"use client";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { Card, CardHeader } from "@/components/headToHead/Card";
import Table from "@/components/headToHead/Table";
import LoadingBackdrop from "@/components/loadingBackdrop/LoadingBackdrop";
import useGetHeadToHeadTeamStats from "@/utils/hooks/useGetHeadToHeadTeamStats";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import useTable from "./useTable";
import styles from "./TeamSuccessRateStats.module.scss";

const ContentContainer = () => {
  const { gameId } = useHeadToHeadContext();
  const { data, isLoading, isError } = useGetHeadToHeadTeamStats(gameId);
  const { columns, tableData } = useTable(data);

  if (isError && !data) {
    return <ErrorComponent />;
  } else if (isLoading && !data) {
    return <LoadingBackdrop loading={isLoading} />;
  }
  return <Table data={tableData} columns={columns} />;
};

const TeamSuccessRateStats = () => (
  <Card>
    <CardHeader title="Team Success Rate Stats" />
    <div className={styles.content}>
      <ContentContainer />
    </div>
  </Card>
);

export default TeamSuccessRateStats;
